import React from 'react';

import {imageUrl} from '../../components/utils';
import {useDayCardQuery} from '../../generated/types';
import {Link, RouteName} from '../../lib/routes';

import css from './day-card.module.css';

const KINDS: Record<string, {label: string; route: RouteName}> = {
	monster: {label: 'Чудовище дня', route: 'monster'},
	spell: {label: 'Заклинание дня', route: 'spell'},
	item: {label: 'Предмет дня', route: 'item'},
};

const today = () => new Intl.DateTimeFormat('sv-SE', {timeZone: 'Europe/Moscow'}).format(new Date());

export const DayCard: React.FC = () => {
	const {data} = useDayCardQuery({ssr: true, variables: {date: today()}});
	const card = data?.dayCard;
	const kind = card && KINDS[card.kind];
	if (!card || !kind) return null;

	return (
		<section className={css.card} aria-labelledby="home-day-card">
			<Link route={kind.route} params={{id: card.id}} className={css.link}>
				{card.imagePath && (
					<span className={css.media}>
						<img className={css.image} src={imageUrl(card.imagePath, 400)} alt="" loading="lazy" />
					</span>
				)}
				<span className={css.text}>
					<span id="home-day-card" className={css.kind}>
						{kind.label}
					</span>
					<span className={css.title}>{card.title}</span>
					{(card.originalTitle || card.subtitle) && (
						<span className={css.subtitle}>{[card.originalTitle, card.subtitle].filter(Boolean).join(' · ')}</span>
					)}
					{card.text && <span className={css.description}>{card.text}</span>}
				</span>
			</Link>
		</section>
	);
};
